type PublicAppConfig = {
  demoEpicPatientId: string;
  demoCernerPatientId: string;
  demoEpicOrgId: string;
  demoCernerOrgId: string;
};

let cached: PublicAppConfig | null = null;

export const loadPublicAppConfig = async (): Promise<PublicAppConfig> => {
  const response = await fetch('/api/public-config', { credentials: 'include' });
  if (!response.ok) {
    throw new Error(`Failed to load public config: ${response.status}`);
  }
  cached = (await response.json()) as PublicAppConfig;
  return cached;
};

export const getPublicAppConfig = (): PublicAppConfig => {
  if (!cached) {
    throw new Error('Public app config was not loaded; loadPublicAppConfig must run before render');
  }
  return cached;
};
